export const environment = {
    production: false,
    firebase: {
        apiKey: 'AIzaSyDeWOosvHqpzpWHnhsAjclUMPGOUPwOfV8',
        authDomain: 'pwrtek-develop.firebaseapp.com',
        databaseURL: 'https://pwrtek-develop-default-rtdb.firebaseio.com',
        projectId: 'pwrtek-develop',
        storageBucket: 'pwrtek-develop.firebasestorage.app',
        messagingSenderId: '670830081662',
        appId: '1:670830081662:web:883077403da6b3f75cca2f',
        measurementId: 'G-HEQCDHK00C',
        logsBucket: 'pwrtek-trailers-logs-develop'
    },
    logsBucket: 'pwrtek-trailers-logs-develop',
};
